<template>

    <section v-if="visible" class="">
        <slot></slot>
    </section>

</template>

<style lang="scss">
    .crud main section{
        @include clearfix();
    }
</style>

<script>
    export default {
        data() {
            return {
                visible: false
            }
        },
        watch: {},
        computed: {
            name(){
                return this.$parent.name;
            }
        },
        methods: {},
        mounted() {
            var that = this;
            
            window.eventBus.$on('crud-show-edit-'+this.name, function (item) {

                that.visible = true;
                window.eventBus.$emit('crud-hide-nav-'+this.name);
                window.eventBus.$emit('crud-hide-new-'+this.name);
                window.eventBus.$emit('crud-hide-view-'+this.name);
            });

            window.eventBus.$on('crud-hide-edit-'+this.name, function (item) {
                that.visible = false;
            });

        }
    }
</script>   
